import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import PDFToWordUploadView from "./PDFToWordUploadView";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";

function PDFToWordMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF To Word Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_to_word", title: "Convert PDF To Word Online" },
    data2: { link: "/pdf_to_word", title: "PDF To DOC, DOCX Online" },
    data3: { link: "/pdf_to_word", title: "PDF To MS Word Converter" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF to Word online instantly. Turn PDFs into editable DOC or DOCX files quickly with our fast, secure PDF to Word converter."
      ></meta>
      <meta
        name="keywords"
        content="pdf to word, convert pdf to word, pdf to doc, pdf to docx, online pdf to word, pdf word converter, editable word from pdf, pdf to word online, pdf document to word, pdf text to word, pdf conversion tool, free pdf to word, secure pdf to word, pdf editor online, pdf file converter, pdf to microsoft document converter, pdf to ms word, pdf to doc online, pdf to docx online, pdf to doc free, pdf to doc converter free, pdf to docx converter free, pdf converter online, pdf converter online free,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PDF View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = 9.9mb */}
        {showEditFileScreen ? (
          <PDFToWordUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["pdf"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our PDF to Word converter online website is a fast, reliable, and user friendly tool designed to convert PDF documents into fully editable Microsoft Word files. This advanced PDF to Word online converter supports both PDF and DOC/DOCX formats, accurately extracting text, images, tables, and formatting from PDF files while maintaining the original layout. Whether you are a student working on assignments, a professional editing reports, or a business handling contracts and official documents, this convert PDF to Word online tool simplifies document editing and content reuse. With a simple upload and convert process, users can instantly transform PDF files into Word documents directly in their browser, no software installation or technical expertise required. Our PDF to Word converter online produces high quality, editable Word files that are perfect for updating, sharing, printing, or archiving. The platform ensures strong security, with files processed safely and automatically removed after conversion to protect sensitive data. By converting static PDFs into editable Word documents, this tool saves time, enhances productivity, and makes document management easier for both personal and professional use. If you’re searching for a fast, secure, and accurate PDF to Word online converter, this website is the ultimate solution for efficient and seamless document conversion." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PDF To Word Converter"
          why_use={[
            {
              title: "Convert Non Editable PDFs into Editable Word Documents",
              description:
                "This PDF to Word converter online allows users to transform static PDF files into fully editable DOC or DOCX formats, making it easy to update content, correct errors, or reuse information.",
            },

            {
              title: "Save Time on Manual Rewriting",
              description:
                "Using a convert PDF to Word online tool eliminates the need to manually copy text or recreate documents, saving time and reducing errors.",
            },

            {
              title: "Preserve Original Formatting",
              description:
                "Our reliable PDF to Word online converter retains fonts, tables, images, columns, and layout, ensuring your converted Word documents match the original PDF.",
            },

            {
              title: "Improve Workflow and Productivity",
              description:
                "With a fast PDF to Word converter online website, students, professionals, and businesses can edit and reuse documents quickly, improving workflow efficiency.",
            },

            {
              title: "Easy Online Access Without Software Installation",
              description:
                "This browser based PDF to Word online tool works without downloading or installing software, allowing users to convert PDF files anytime from any device.",
            },

            {
              title: "Ideal for Business and Academic Use",
              description:
                "Our PDF to Word online converter is perfect for editing contracts, resumes, reports, assignments, and other professional or academic documents.",
            },

            {
              title: "Simplifies Content Editing and Collaboration",
              description:
                "Converting PDF to Word online allows easy editing, updating, and collaborative work, which is not possible with static PDF files.",
            },

            {
              title: "Supports Complex PDF Documents",
              description:
                "Advanced PDF to Word converter online tools can handle multi page PDFs, tables, and complex layouts, ensuring accurate conversion for professional use.",
            },

            {
              title: "Secure and Reliable Conversion",
              description:
                "Our secure PDF to Word online website ensures files are handled safely, protecting sensitive information during the conversion process.",
            },
          ]}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PDFToWordMain;
